import React from 'react';
import gql from 'graphql-tag';
import { toast } from 'react-toastify';
import uuidv4 from 'uuid/v4';

import client from '../../../utils/apolloClient';

const searchApiActionsQuery = gql`
  query searchApiActionsQuery($input: SearchInput) {
    search_cms_api_actions(input: $input) {
      api_actions {
        api_action_id
        name
        description
        status
        audit {
          created_at
          created_by
          updated_at
          updated_by
        }
        error {
          code
          description
        }
      }
      total_pages
      total_size
    }
  }
`;

const fetchApiActions = async ({
  apiActionId,
  name,
  status,
  from,
  size,
  sort,
}) => {
  const input = { from, size, sort };

  input.filter = {};

  input.filter.cms_api_action_filter = {};

  if (apiActionId) {
    input.filter.cms_api_action_filter.api_action_id = apiActionId;
  }

  if (name) {
    input.filter.cms_api_action_filter.name = name;
  }

  if (status) {
    input.filter.cms_api_action_filter.status = status;
  }

  try {
    const data = await client.clientPrivate.query({
      client: client.clientPrivate,
      query: searchApiActionsQuery,
      variables: { input },
      fetchPolicy: 'network-only',
    });
    if (data && data.data && data.data.search_cms_api_actions) {
      return data.data.search_cms_api_actions;
    }
    return null;
  } catch (error) {
    throw error;
  }
};

export const useCmsData = ({ apiActionId, name, status, from, size, sort }) => {
  const [loading, setLoading] = React.useState(false);
  const [pageCount, setPageCount] = React.useState(null);
  const [totalElements, setTotalElements] = React.useState(null);
  const [cmsData, setCmsData] = React.useState(null);
  const [reload, setReload] = React.useState(uuidv4());

  React.useEffect(() => {
    let loadData = true;
    const fetchData = async () => {
      setLoading(true);
      try {
        const data = await fetchApiActions({
          apiActionId,
          name,
          status,
          from,
          size,
          sort,
        });
        if (loadData) {
          setPageCount(data.total_pages);
          setTotalElements(data.total_size);
          setCmsData(data?.api_actions ?? []);
          setLoading(false);
        }
      } catch (error) {
        toast.error(error);
      } finally {
        setLoading(false);
      }
    };
    fetchData();

    return () => {
      loadData = false;
    };
  }, [apiActionId, name, status, from, size, sort, reload]);

  return {
    loading,
    pageCount,
    totalElements,
    cmsData,
    refetch: () => setReload(uuidv4()),
  };
};

export default {};
